var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 2.57227C8.09266 2.57227 4.91406 5.75091 4.91406 9.65798C4.91406 15.9407 11.2899 20.8854 11.5614 21.0929L11.9998 21.428L12.438 21.0929C12.7095 20.8853 19.0855 15.9407 19.0855 9.65798C19.0855 5.75086 15.907 2.57227 11.9998 2.57227ZM11.9993 19.5828C10.6028 18.381 6.35777 14.3415 6.35777 9.65798C6.35777 6.54689 8.88841 4.01597 11.9998 4.01597C15.1106 4.01597 17.6418 6.54694 17.6418 9.65798C17.6418 14.3314 13.3952 18.3792 11.9993 19.5828Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8901 6.70117C10.3725 6.70117 9.1416 7.9315 9.1416 9.44969C9.1416 10.9673 10.3725 12.1979 11.8901 12.1979C13.408 12.1979 14.6386 10.9673 14.6386 9.44969C14.6386 7.9315 13.408 6.70117 11.8901 6.70117Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.a745f661d66dc8c9ae0a82c9de3c6ea4.svg";
export { ForwardRef as ReactComponent };